import { saveAs } from 'file-saver';
import { regexFileName } from 'forms/validations';

export const saveFile = ({ response }) => {
	const fileName = response.headers['content-disposition'];
	const decodedFileName = decodeURI(fileName);
	const parsedFileName = decodedFileName.match(regexFileName)[1].replace(/("|\r)/g, '');

	const contentType = response.headers['content-type'];
	const parsedContentType = contentType.replace(/\r/g, '');

	const blob = new Blob([response.body], { type: parsedContentType });
	saveAs(blob, parsedFileName);
};
